import React, {Suspense} from 'react';
import {Footer, Header} from './global';
import {Navigate, Outlet, createBrowserRouter} from 'react-router-dom';
import NotFound from './global/NotFound';

const pagePath = {
    plpUrl: '/productlist',
    solrSearchResultUrl: '/search',
    infoCaptureUrl: '/info-capture',
    auth: '/auth',
    login: '/auth/login',
    register: '/auth/register',
    welcome: '/auth/welcome',
    companyRegistration: '/company-registration',
    businessVerification: '/business-verification',
    appointment: '/appointment',
    delivery: '/delivery',
    cart: '/cart',
    orderSummary: '/order-summary',
    orderConfirmation: '/order-confirmation',
    orderTracking: '/order-tracking'
};

const ProductListing = React.lazy(() => import('./components/ProductListing.Component'));
const InfoCaptureForm = React.lazy(() => import('./components/InfoCaptureForm.Component'));
const SolrSearchResult = React.lazy(() => import('./components/SolrSearchResult.Component'));
const AuthenticationComponent = React.lazy(() => import('./components/Authentication.Component'));
const CompanyRegistrationComponent = React.lazy(() => import('./components/CompanyRegistration.Component'));
const BusinessVerificationComponent = React.lazy(() => import('./components/BusinessVerification.Component'));
const AppointmentDateComponent = React.lazy(() => import('./components/AppointmentDate.Component'));
const DeliveryDetailsComponent = React.lazy(() => import('./components/DeliveryDetails.Component'));
const CartComponent = React.lazy(() => import('./components/Cart.Component'));
const OrderSummaryComponent = React.lazy(() => import('./components/OrderSummary.Component'));
const OrderConfirmationComponent = React.lazy(() => import('./components/OrderConfirmation.Component'));
const OrderTrackingComponent = React.lazy(() => import('./components/OrderTracking.Component'));

const ErrorDisplay = () => {
    return;
};

const router = createBrowserRouter([
    {
        element: (
            <Suspense fallback={null}>
                <Header />
                <Outlet />
                <Footer />
            </Suspense>
        ),
        errorElement: <ErrorDisplay />,
        children: [
            {
                path: pagePath.plpUrl,
                element: <ProductListing />
            },
            {
                path: pagePath.infoCaptureUrl,
                element: <InfoCaptureForm />
            },
            {
                path: pagePath.solrSearchResultUrl,
                element: <SolrSearchResult />
            },
            {
                path: '/',
                element: <ProductListing />
            },
            {
                path: pagePath.cart,
                element: <CartComponent />
            },
            {
                path: pagePath.orderSummary,
                element: <OrderSummaryComponent />
            },
            {
                path: pagePath.orderConfirmation,
                element: <OrderConfirmationComponent />
            },
            {
                path: pagePath.orderTracking,
                element: <OrderTrackingComponent />
            }
        ]
    },
    {
        element: (
            <Suspense fallback={null}>
                <Outlet />
            </Suspense>
        ),
        errorElement: <ErrorDisplay />,
        children: [
            {
                path: pagePath.auth,
                children: [
                    {path: '', element: <AuthenticationComponent isLogin />},
                    {
                        path: pagePath.register,
                        element: <AuthenticationComponent />
                    },
                    {
                        path: pagePath.login,
                        element: <AuthenticationComponent isLogin />
                    },
                    {
                        path: pagePath.welcome,
                        element: <AuthenticationComponent isWelcome />
                    }
                ]
            },
            {
                path: pagePath.companyRegistration,
                element: <CompanyRegistrationComponent />
            },
            {
                path: pagePath.businessVerification,
                element: <BusinessVerificationComponent />
            },
            {
                path: pagePath.appointment,
                element: <AppointmentDateComponent />
            },
            {
                path: pagePath.delivery,
                element: <DeliveryDetailsComponent />
            }
        ]
    },
    {
        path: '/error-pages/404',
        element: (
            <>
                <Header />
                <NotFound />
                <Footer />
            </>
        )
    },
    {
        path: '*',
        element: <Navigate to='/error-pages/404' replace />
    }
]);

export {pagePath, router};
